import qs from "querystringify";
import {
  History,
  createBrowserHistory,
  createMemoryHistory,
  UnregisterCallback,
  LocationListener,
  Location,
} from "history";
import { observable, action } from "mobx";

export interface RouterState {
  path: string;
  search: string | null;
  hash: string | null;
  query: ObjectAny;
}

export type RouterOnChange = (s: RouterState) => void;

export class RouterStore {

  @observable s: RouterState;
  @observable is404: boolean = false;

  history: History;
  unlisten: UnregisterCallback;
  onChange?: RouterOnChange;

  constructor(initialState?: RouterState, onChange?: RouterOnChange) {

    this.onChange = onChange;

    this.history = typeof window !== "undefined" ?
      createBrowserHistory() :
      createMemoryHistory();

    this.unlisten = this.history.listen(this.listen);

    this.s = observable({
      path: this.history.location.pathname,
      search: this.history.location.search,
      hash: this.history.location.hash,
      query: qs.parse(this.history.location.search),
      ...(initialState || {}),
    });

  }

  getOrigin = () => {
    let origin = window.location.origin;
    if (!origin) {
      origin = window.location.protocol + "//"
        + window.location.hostname
        + (window.location.port ? ":" + window.location.port : "");
    }
    return origin;
  }

  @action set404 = (is404: boolean) => this.is404 = is404;
  @action update = (data: Partial<RouterState>) => {
    this.s = { ...this.s, ...data };
  }
  @action push = (path: string) => {
    this.history.push(path);
  }
  @action listen: LocationListener = (location) => {
    this.s = {
      path: location.pathname,
      search: location.search,
      hash: location.hash,
      query: qs.parse(location.search),
    };
    if (this.onChange) {
      this.onChange(this.s);
    }
  }

}
